<ds-modal
  #comfyActionPlanModal
  [ds-modal-trigger-for]="comfyActionPlanModal"
  [isModalOpen]="modalIsOpen()"
  [dimensionsConfig]="{ width: '400px' }"
  [isDismissable]="true"
  (isModalOpenChange)="modalIsOpen.set($event)"
  (modalDismiss)="modalDismissed()"
>
  <ds-box-header icon="flow_chart" size="md">{{ 'backoffice.comfyActionPlanModal.title' | translate }}</ds-box-header>

  @if(actionPlanOptions()) {
  <ds-box-content>
    <div class="w-100 d-flex flex-column align-items-center justify-content-center">
      <span class="mb-4x">{{ 'backoffice.comfyActionPlanModal.description' | translate }}</span>

      @for (actionPlan of actionPlanOptions(); let last = $last; track $index) {
      <button
        ds-toggle-button
        [icon]="actionPlan.isActive ? 'eye' : 'eye_off'"
        [checked]="actionPlan.isActive"
        (click)="onActionPlan(actionPlan)"
      >
        {{ 'backoffice.comfyActionPlanModal.' + actionPlan.actionPlanItem | translate }}
      </button>

      @if (!last) {
      <div class="vertical-divider"></div>
      } @else {
      <span class="text-smallprint text-neutral mt-1x">{{ 'backoffice.comfyActionPlanModal.note' | translate }}</span>
      } }
    </div>
  </ds-box-content>
  }

  <ds-box-footer>
    <button #dsModalDismissElement ds-button class="me-2x" id="btn-cancel-modal" variant="outline">
      {{ 'common.buttons.cancel' | translate }}
    </button>

    <ds-button class="ms-2x" icon="save" [disabled]="!actionPlanChanged()" (click)="onSave()">
      {{ 'common.buttons.save' | translate }}
    </ds-button>
  </ds-box-footer>
</ds-modal>
